import { AccessTimeRounded } from '@mui/icons-material';
import {
  DonutDetailsChart,
  Widget,
  WidgetContent,
  WidgetHeader,
  WidgetIcon,
  useScrollIntoView,
} from '@procureai/ui-mui';

import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { PlaceholderWidget } from '~/components/PlaceholderWidget/PlaceholderWidget';

import { useDeliveryReliability } from './DeliveryReliabilityWidget.hooks';

export const DeliveryReliabilityWidget = () => {
  const [widgetRef, active] = useScrollIntoView({ hash: 'delivery-reliability' });
  const { title, subTitle, timelinessProps, isLoading } = useDeliveryReliability();

  return (
    <Widget ref={widgetRef} active={active} data-intercom-target="DeliveryReliabilityWidget">
      <WidgetHeader
        title={title}
        subTitle={subTitle}
        icon={<WidgetIcon icon={<AccessTimeRounded fontSize="small" />} />}
      />
      {timelinessProps ? (
        <WidgetContent>{timelinessProps && <DonutDetailsChart {...timelinessProps} />}</WidgetContent>
      ) : isLoading ? (
        <CircularProgressCentered sx={{ position: 'relative' }} />
      ) : (
        <PlaceholderWidget />
      )}
    </Widget>
  );
};
